import {Component} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {FirstAccessService} from './firstAccess.service';
import {Router} from '@angular/router';
import {SharedFirstAccessService} from '../../services/sharedFirstAccess.service';
import {finalize} from 'rxjs/operators';
import {User} from '@models/old/user.model';
import {NotifyService} from '@services/notify.service';

@Component({
    selector: 'app-first-access',
    templateUrl: './first-access.component.html',
    styleUrls: ['../../login.component.scss'],
    standalone: false
})
export class FirstAccessComponent {

  private readonly sucessMessage: string = 'Você receberá um e-mail com instruções para completar seu acesso.';
  private readonly errorMessage: string = 'Falha ao realizar a operação. Contate o time de atendimento ao cliente.';

  public enableBtnEnviar = true;

  formFirstAccess = this.frmBuilder.group({
    documentNumber: ['', [Validators.required, Validators.maxLength(14)]]
  });

  constructor(private frmBuilder: FormBuilder,
              private firstAccessService: FirstAccessService,
              private notifyService: NotifyService) {
  }

  onSubmit() {
    try {
      const documentNumber:string = this.formFirstAccess.value?.documentNumber?.replace(/\D/g, '');
      if (documentNumber === '') {
        this.notifyService.showWarning('Atenção!', 'O número de CPF deve ser informado.');
      } else if (documentNumber.length != 11) {
        this.notifyService.showWarning('Atenção!', 'O número de CPF deve conter 11 dígitos.');
      } else {
        this.firstAccess(documentNumber);
      }
    } catch (e) {
      this.notifyService.showError('Error', this.errorMessage);
      console.error(e);
    }
  }

  firstAccess(documentNumber: string) {
    this.firstAccessService
      .creatLead(documentNumber)
      .subscribe(
        () => {
          this.notifyService.showSuccess('', this.sucessMessage);
          this.enableBtnEnviar = false;
        },
        (error) => {
          console.error('Erro ao criar lead:', error);
        }
      );
  }
}
